module.exports = __webpack_public_path__ + "img/4d5daa9.png";